import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledBoxRow, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Grid, Typography, useTheme} from "@mui/material";
import {Star, StarBorder} from "@mui/icons-material";
import {BORDER_RADIUS_LARGE, CARD_SHADOW, PD_LG, PD_MD, PD_SM, PD_XSM} from "@/shared/dimens";
import {TestimonialsSectionData} from "../../types";

export function TestimonialsSection(props: { data: TestimonialsSectionData }): ReactElement {
  const theme = useTheme();
  return <SectionContainer>
    {props.data.title
      ? <StyledHeadingVariant default_={3}>{props.data.title}</StyledHeadingVariant>
      : null}
    <Grid container>
      {props.data.testimonials.map((testimonial, i) =>
        <Grid key={i} xs={12} md={6} lg={4} style={{display: "flex", padding: PD_MD}}>
          <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            borderRadius: BORDER_RADIUS_LARGE,
            boxShadow: CARD_SHADOW,
            backgroundColor: "#fff",
            padding: PD_LG,
            gap: PD_LG,
            width: "100%",
          }}>
            <StyledBoxColumn style={{gap: PD_MD}}>
              {testimonial.rating > 0
                ? <StyledBoxRow style={{gap: PD_XSM}}>
                  {Array.from({length: 5}).map((_, j) =>
                    j < testimonial.rating
                      ? <Star key={j} style={{fontSize: 18, color: theme.palette.primary.main}}/>
                      : <StarBorder key={j} style={{fontSize: 18, color: theme.palette.primary.main}}/>
                  )}
                </StyledBoxRow>
                : null}
              <Typography style={{lineHeight: 1.8, fontStyle: "italic", opacity: 0.8}}>
                "{testimonial.quote}"
              </Typography>
            </StyledBoxColumn>
            <StyledBoxRow style={{alignItems: "center", gap: PD_SM}}>
              {testimonial.authorImageUrl
                ? <img
                  src={testimonial.authorImageUrl}
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    objectFit: "cover",
                    flexShrink: 0,
                  }}/>
                : null}
              <StyledBoxColumn style={{gap: 0}}>
                <Typography style={{fontWeight: "600"}}>{testimonial.authorName}</Typography>
                {testimonial.authorTitle
                  ? <Typography variant="body2" style={{opacity: 0.55}}>{testimonial.authorTitle}</Typography>
                  : null}
              </StyledBoxColumn>
            </StyledBoxRow>
          </div>
        </Grid>
      )}
    </Grid>
  </SectionContainer>;
}
